import axios from 'axios';

const initialState = {
  suppressions: [],
  errorMessage: '',
}

export default {
  namespaced: true,
  state: { ...initialState },
  mutations: {
    setSuppressions(state, data) {
      state.suppressions = data;
    },
    resetSuppressions(state) {
      state.suppressions = [];
    },
    setUnsubscribed(state) {
      const unsubStatus = 'unsub_global';
      if (!state.suppressions.includes(unsubStatus)) {
        state.suppressions.push(unsubStatus);
      }
    },
    setErrorMessage(state, message) {
      state.errorMessage = message;
    },
  },
  actions: {
    async getEmailSuppressions({ commit }, email) {
      try {
        const resp = await axios.get(`${process.env.VUE_APP_COMMUNICATIONS_API_BASE_URL}/email/suppressions?email=${email}`);
        commit('setSuppressions', resp.data);
      }
      catch(error) {
        commit('setErrorMessage', error);
        commit('resetSuppressions');
      }
    },
    async getUnsubscribedStatus({ commit }, email) {
      try {
        const resp = await axios.get(`${process.env.VUE_APP_CONTACTS_MS_BASE_URL}/check-unsubscribed?email=${email}`);
        if (resp.status !== 204) {
          commit('setUnsubscribed');
        }
      }
      catch(error) {
        commit('setErrorMessage', error);
      }
    },
  },
}
